export class SalutationViewModel{
    salutationId: string | undefined;
    description: string | undefined;
}